import { getParentsOrSelf } from '../get-parents-or-self';

export function getParents(element: HTMLElement) {
	return getParentsOrSelf(element.parentElement);
}
